import { useEffect, useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import MotoristasTable from "../../../components/motoristas/table/indes";
import { VerticalContainer } from "../../../components/styled";
import history from "../../../routes/history";
import { deleteMotorista, getMorotistas, getMotoristas } from "../../../services/motoristas";

const { Search } = Input;

export default function ListMotoristas() {
  const [filter, setFilter] = useState("");
  const [motoristas, setMotoristas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const getMorotistasPaginated = async () => {
    setLoading(true);
    try {
      const motoristasGet = await getMotoristas(page, filter);
      setMotoristas(motoristasGet);
      setTotal(motoristasGet.length);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getMorotistasPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };
  async function confirm(record) {
    await deleteMotorista(record.id);
    await getMorotistasPaginated();
  }

  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter("");
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: "50%" }}
          placeholder="Pesquisar motorista..."
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            history.push("/adicionar-motorista");
          }}
          style={{ width: "100%!important" }}
          block
        >
          <PlusOutlined />
          Adicionar motorista
        </Button>
        <br />
        <MotoristasTable
          loading={loading}
          handleTableChange={handleTableChange}
          motoristas={motoristas}
          total={total}
          confirm={confirm}
        />
      </VerticalContainer>
    </>
  );
}
